var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header',[_vm._v("新增任务")]),_c('Form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }